<p-card [class]="gradientStyleClass">
  <div class="mt-3">
    <img src="images/content/needhelp.svg" [alt]="i18n?.i18nLng()['NEEDHELP']" width="100px" height="auto">
  </div>
  <div class="mt-2 text-2xl font-bold text-white">
    {{ i18n?.i18nLng()['NEEDHELP'] }}
  </div>
  <div class="mt-3 text-white text-lg line-height-3 contact-mail-link">
    <span [innerHTML]="i18n?.i18nLng()['NEEDHELPINFO'] | safeHtml"></span>
  </div>
  <div class="need-help-links mt-3 mb-3">
    <!-- on errorpage (user is not logged in) routerLink doesn't work    -->
    @if (!showContactSPS) {
      <a class="text-lg line-height-3" routerLink="/helpcontact">
        <span>{{ i18n?.i18nLng()['CONTACT'] }}</span>
        <i class="pi pi-chevron-right"></i>
      </a>
    } @else {
      <a class="text-lg line-height-3" [href]="spsContactUrl" target="_blank">
        <span>{{ i18n?.i18nLng()['CONTACT'] }}</span>
        <i class="pi pi-chevron-right"></i>
      </a>
    }
    <a class="text-lg line-height-3" [href]="apiUrl" target="_blank">
      <span>{{ i18n?.i18nLng()['APIREFERENCE'] }}</span>
      <i class="pi pi-chevron-right"></i>
    </a>
    <a class="text-lg line-height-3" [href]="manualUrl" target="_blank">
      <span>{{ i18n?.i18nLng()['USERMANUAL'] }}</span>
      <i class="pi pi-chevron-right"></i>
    </a>
    <a class="text-lg line-height-3" [href]="faqUrl" target="_blank">
      <span>FAQ</span>
      <i class="pi pi-chevron-right"></i>
    </a>
    <!-- on errorpage (user is not logged in) routerLink doesn't work    -->
    <!--
    @if (!showContactSPS) {
      <a class="text-lg line-height-3" routerLink="/helpfaq">
        <span>FAQ</span>
        <i class="pi pi-chevron-right"></i>
      </a>
    }
    -->
  </div>
</p-card>
